import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { SpinnerButton, ValidationError, ConfirmModal } from 'components';
import AgreementDraftContainer from './agreement-draft/agreement-draft-container';

export class Footer extends React.Component {

  static propTypes = {
    postInvoice: PropTypes.func.isRequired,
    setSubmitted: PropTypes.func.isRequired,
    setTermsAccepted: PropTypes.func.isRequired,
    openPreviewModal: PropTypes.func.isRequired,
    closePreviewModal: PropTypes.func.isRequired,
    openSendModal: PropTypes.func.isRequired,
    closeSendModal: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    invoiceId: PropTypes.string,
    submitted: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    posting: PropTypes.bool.isRequired,
    postError: PropTypes.bool.isRequired,
    invoice: PropTypes.object.isRequired,
    termsAccepted: PropTypes.bool.isRequired,
    validationErrors: PropTypes.object,
    registerAssignmentTool: PropTypes.bool.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      termsAccepted: false,
      submitted: false,
      renderConfirmModal: false,
      preReport: false
    };

    this.onCloseClick = this.onCloseClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setPreReportTrue = this.setPreReportTrue.bind(this);
  }

  handleClick (e) {
    this.setState({
      termsAccepted: e.target.checked,
      submitted: false
    });
    this.props.setTermsAccepted(e.target.checked);
  }

  /**
   * Required function when you have the checked attribute on a checkbox
   */
  onChange (e) {}

  componentDidUpdate (prevProps) {
    if (!prevProps.invoice.preReport && this.props.invoice.preReport) {
      if (!this.state.preReport) {
        this.setPreReportTrue();
      }
    }
  }

  setPreReportTrue () {
    this.setState({
      preReport: true
    });
  }

  renderTermsError () {
    if (this.props.invoice.submitted && !this.props.invoice.termsAccepted) {
      return (
        <p className="error"><Translate content='ACCEPT_TERMS'/></p>
      );
    }
  }

  renderInvoiceError () {
    if (this.state.submitted && !this.props.valid) {
      return (
        <p className="error"><Translate content='INVOICE_NOT_VALID'/></p>
      );
    }
  }

  renderInvoiceButtonPreReport () {
    if (this.props.registerAssignmentTool) {
      let saveUpdateStr = (this.props.invoiceId) ? 'UPDATE_INVOICE' : 'REGISTER_SAVE_DRAFT';
      let classes = 'btn outlined blue';

      if (this.props.registerAssignmentTool) {
        saveUpdateStr = (this.props.invoiceId)
          ? this.props.translationPrefix + 'UPDATE_INVOICE'
          : this.props.translationPrefix + 'REGISTER_SAVE_DRAFT';
        classes = 'btn';
      }

      return (<SpinnerButton
        text={proxyCounterpart(saveUpdateStr)} graySpinner={'true'}
        loading={this.props.posting && this.props.invoice.preReport}
        classes={classes}
        callback={this.props.onClickSave}/>);
    }
  }

  renderInvoiceButtonCreate () {
    if (this.props.registerAssignmentTool) {
      return;
    }

    let shouldUpdate = this.props.invoiceId && !this.state.preReport;

    let sendInvoiceText = null;

    if (shouldUpdate) {
      sendInvoiceText = 'UPDATE_INVOICE';
    } else if (this.props.invoiceId && this.state.preReport) {
      sendInvoiceText = 'INVOICE_TOOL_CREATE_INVOICE_BUTTON';
    } else {
      sendInvoiceText = 'INVOICE_TOOL_COMPLETE_BUTTON';
    }

    return (
      <SpinnerButton
        text={proxyCounterpart(sendInvoiceText)}
        loading={this.props.posting && !this.props.invoice.preReport}
        classes='btn'
        callback={this.props.openSendModal}
      />
    );
  }

  renderPreviewButton () {
    if (!this.props.registerAssignmentTool) {
      return (
        <button className='invoice-tool-preview-invoice-link' onClick={this.props.openPreviewModal}>
          <span><Translate content='INVOICE_TOOL_PREVIEW_INVOICE_TEXTLINK' /></span>
        </button>
      );
    }

    return null;
  }

  renderCancelButton () {
    return (
      <button className='btn outlined blue' onClick={this.onCloseClick}>
        <span><Translate content={this.props.translationPrefix + 'CANCEL_BUTTON'} /></span>
      </button>
    );
  }

  renderPostError () {
    if (this.props.postError) {
      return (<ValidationError errors={this.props.validationErrors} />);
    }
  }

  onCloseClick () {
    this.setState({
      renderConfirmModal: true
    });
  }

  closeModal (confirm) {
    if (confirm) {
      this.context.router.replace('/activities');
    } else {
      this.setState({
        renderConfirmModal: false
      });
    }
  }

  renderConfirmModal () {
    if (this.state.renderConfirmModal) {
      return (
        <ConfirmModal callback={this.closeModal} message={proxyCounterpart('CONFIRM_CLOSE_TOOL')} />
      );
    }
  }

  render () {
    return (
      <div className='invoice-footer section-padding'>
        <div className='checkbox-holder'>
          <input
            id='terms-conditions'
            type='checkbox' onChange={this.onChange}
            name='rot' value={this.state.termsAccepted} onClick={this.handleClick} />
          <label htmlFor='terms-conditions'><span></span>
            <AgreementDraftContainer/>
          </label>
        </div>
        {this.renderTermsError()}
        {this.renderInvoiceError()}
        {this.renderPostError()}
        {this.renderPreviewButton()}
        <div className='button-holder'>
          {this.renderCancelButton()}
          {this.renderInvoiceButtonPreReport()}
          {this.renderInvoiceButtonCreate()}
        </div>
        {this.renderConfirmModal()}
      </div>
    );
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/footer/footer.js
 **/